import { Link } from '@mui/material';

import type { LinkProps } from '@mui/material';

export const Or2ButtonStyledAsLink = ({ sx, ...props }: LinkProps) => {
  return (
    <Link component="button" sx={{ paddingBottom: '2px', ...sx }} {...props} />
  );
};
